/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "pay-mastercard-6b4ad786--sprite",
  "use": "pay-mastercard-6b4ad786--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"pay-mastercard-6b4ad786--sprite\"><g transform=\"translate(0 6.09)\"><g opacity=\"0\"><rect width=\"36\" height=\"23.81\" fill=\"#fff\" /></g><rect width=\"9.497\" height=\"15.511\" transform=\"translate(13.253 4.148)\" fill=\"#ff5f00\" /><path d=\"M19.637,17.317A9.847,9.847,0,0,1,23.4,9.563a9.864,9.864,0,1,0,0,15.511,9.847,9.847,0,0,1-3.767-7.757Z\" transform=\"translate(-5.405 -5.412)\" fill=\"#eb001b\" /><path d=\"M120,64.744v-.318h.137V64.36h-.326v.066h.129v.318Zm.633,0V64.36h-.1l-.115.274-.115-.274h-.1v.384h.071v-.29l.107.249h.074l.107-.249v.29Z\" transform=\"translate(-86.982 -46.726)\" fill=\"#f79e1b\" /><path d=\"M81.65,17.307a9.864,9.864,0,0,1-15.96,7.754,9.864,9.864,0,0,0,0-15.511A9.864,9.864,0,0,1,81.65,17.3Z\" transform=\"translate(-47.691 -5.401)\" fill=\"#f79e1b\" /></g><rect width=\"36\" height=\"36\" fill=\"none\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
